export const cannedSettings = {
    az: [
        {
            category: "type",
            clientInteraction: "multiple",
            clientRules: {
                operand0: {
                    contains: "Option_AssistedLivingCenter",
                    operator: "naryvalue",
                    question: "Question_CommunityTypes",
                },
                operand1: {
                    contains: "Option_AssistedLivingHome",
                    operator: "naryvalue",
                    question: "Question_CommunityTypes",
                },
                operator: "or",
            },
            clientTitle: "Care Services",
            communityInteraction: "multiple",
            communityRules: {
                operand0: {
                    contains: "Option_AssistedLivingCenter",
                    operator: "naryvalue",
                    question: "Question_CommunityTypes",
                },
                operand1: {
                    contains: "Option_AssistedLivingHome",
                    operator: "naryvalue",
                    question: "Question_CommunityTypes",
                },
                operator: "or",
            },
            communityTitle: "Care Services",
            key: "Question_CareServices",
            matchingCriteria: "clientsubset",
            order: 1200,
            prompts: [
                {
                    client: "Directed Care",
                    community: "Directed Care",
                    key: "Option_Directed",
                    order: 100,
                },
                {
                    client: "Personal Care",
                    community: "Personal Care",
                    key: "Option_Personal",
                    order: 200,
                },
                {
                    client: "Supervisory Care",
                    community: "Supervisory Care",
                    key: "Option_Supervisory",
                    order: 300,
                },
            ],
            questionType: "nary",
            supportAnyAndAllSearch: "true",
        },
        {
            category: "finance",
            clientInteraction: "binary",
            clientTitle: "ALTCS Needed",
            communityInteraction: "binary",
            communityTitle: "Accepts ALTCS",
            internal_key: "ALTCS_Available",
            key: "Question_ALTCS",
            matchingCriteria: "equal",
            order: 60100,
            questionType: "binary",
        },
        {
            category: "finance",
            clientInteraction: "none",
            communityInteraction: "multiple",
            communityRules: {
                operator: "binaryvalue",
                question: "Question_ALTCS",
            },
            communityTitle: "ALTCS Provider",
            internal_key: "ALTCS_Provider",
            key: "Question_ALTCSProv",
            order: 61000,
            prompts: [
                {
                    community: "Banner",
                    key: "Option_Banner",
                    order: 100,
                },
                {
                    community: "Bridgeway",
                    key: "Option_Bridgeway",
                    order: 200,
                },
                {
                    community: "MercyCare",
                    key: "Option_MercyCare",
                    order: 300,
                },
                {
                    community: "United Healthcare",
                    key: "Option_United",
                    order: 400,
                },
            ],
            questionType: "nary",
        },
        {
            category: "finance",
            clientInteraction: "date",
            clientRules: {
                operator: "binaryvalue",
                question: "Question_ALTCS",
            },
            clientTitle: "ALTCS Date Submitted",
            communityInteraction: "none",
            key: "Question_ALTCSDate",
            order: 62000,
            questionType: "date",
        },
        {
            category: "finance",
            clientInteraction: "multiline",
            clientRules: {
                operator: "binaryvalue",
                question: "Question_ALTCS",
            },
            clientTitle: "ALTCS Case Manager",
            communityInteraction: "none",
            key: "Question_ALTCS_CM",
            order: 63000,
            questionType: "text",
        },
    ],
    ca: [
        {
            category: "summary",
            clientInteraction: "binary",
            clientTitle: "Completed Form 602a",
            communityInteraction: "none",
            key: "Question_602a",
            order: 3000,
            questionType: "binary",
        },
        {
            category: "finance",
            clientAnnotation: "single",
            clientInteraction: "binary",
            clientTitle: "Will Need Medi-Cal",
            communityInteraction: "binary",
            communityTitle: "Has Medi-Cal Contract",
            internal_key: "Medicaid",
            key: "Question_Medicaid",
            matchingCriteria: "equal",
            order: 60100,
            questionType: "binary",
        },
        {
            category: "type",
            clientInteraction: "binary",
            clientAnnotation: "single",
            clientTitle: "Needs Assisted Living Waiver",
            communityInteraction: "binary",
            communityAnnotation: "none",
            communityTitle: "Assisted Living Waiver Program",
            order: 125,
            questionType: "binary",
            supportAnyAndAllSearch: "true",
            internal_key: "AssistedLivingWaiver",
            key: "Question_AssistedLivingWaiver",
        },
    ],
    core: [
        {
            category: "type",
            clientInteraction: "multiple",
            clientTitle: "Bathroom",
            communityInteraction: "multiple",
            communityTitle: "Bathrooms",
            internal_key: "Bathrooms",
            key: "Question_Bathrooms",
            matchingCriteria: "clientsubset",
            order: 50100,
            prompts: [
                {
                    client: "Shared",
                    community: "Shared",
                    key: "Option_Shared",
                    order: 1000,
                },
                {
                    client: "Private",
                    community: "Private",
                    key: "Option_Private",
                    order: 2000,
                },
            ],
            questionType: "nary",
            supportAnyAndAllSearch: "true",
        },
        {
            category: "summary",
            clientInteraction: "multiline",
            clientTitle: "Reason for Seeking Supportive Housing and/or Care Services",
            communityInteraction: "none",
            key: "Question_ReasonForCare",
            order: 1000,
            questionType: "text",
        },
        {
            category: "staff",
            clientInteraction: "none",
            communityAnnotation: "perAnswer",
            communityInteraction: "multiple",
            communityTitle: "Professional Staff Type",
            key: "Question_ProStaff",
            order: 1000,
            prompts: [
                {
                    community: "Physician",
                    communityAnnotation: true,
                    key: "Option_Physician",
                    order: 1000,
                },
                {
                    community: "Psychiatrist",
                    communityAnnotation: true,
                    key: "Option_Psychiatrist",
                    order: 2000,
                },
                {
                    community: "Other Practitioners Available To Residents",
                    communityAnnotation: true,
                    key: "Option_Other",
                    order: 3000,
                },
                {
                    community: "Nursing Director",
                    communityAnnotation: true,
                    key: "Option_NursingDirector",
                    order: 4000,
                },
                {
                    community: "Nurse Practitioner on Staff",
                    communityAnnotation: true,
                    key: "Option_NursePractitioner",
                    order: 5000,
                },
                {
                    community: "Registered Nurse on Staff",
                    communityAnnotation: true,
                    key: "Option_RegisteredNurse",
                    order: 6000,
                },
                {
                    community: "Licensed Practical Nurses on Staff",
                    communityAnnotation: true,
                    key: "Option_LicensedPracticalNurse",
                    order: 7000,
                },
                {
                    community: "Aides",
                    communityAnnotation: true,
                    key: "Option_Aides",
                    order: 8000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "staff",
            clientInteraction: "none",
            communityInteraction: "binary",
            communityTitle: "Live-in Caregivers",
            key: "Question_LiveInCaregivers",
            order: 3000,
            questionType: "binary",
        },
        {
            category: "staff",
            clientInteraction: "none",
            communityInteraction: "binary",
            communityTitle: "24 Hour Awake Staff",
            key: "Question_24HourAwake",
            order: 4000,
            questionType: "binary",
        },
        {
            category: "staff",
            clientInteraction: "none",
            communityInteraction: "binary",
            communityTitle: "Shift Workers",
            key: "Question_ShiftWorkers",
            order: 5000,
            questionType: "binary",
        },
        {
            category: "staff",
            clientInteraction: "none",
            communityInteraction: "multiline",
            communityTitle: "Other Staff Notes",
            key: "Question_StaffNotes",
            order: 7112009,
            questionType: "text",
        },
        {
            category: "finance",
            clientAnnotation: "single",
            clientInteraction: "binary",
            clientTitle: "Veteran (VA Benefits)",
            communityInteraction: "none",
            internal_key: "VeteranBenefits",
            key: "Question_VA",
            order: 40100,
            questionType: "binary",
        },
        {
            category: "finance",
            clientAnnotation: "single",
            clientInteraction: "binary",
            clientTitle: "Long Term Care Insurance",
            communityInteraction: "none",
            internal_key: "LongTermCareInsurance",
            key: "Question_LTCI",
            order: 41000,
            questionType: "binary",
        },
        {
            category: "finance",
            clientAnnotation: "single",
            clientInteraction: "binary",
            clientTitle: "Owns Home",
            communityInteraction: "none",
            key: "Question_OwnsHome",
            order: 42000,
            questionType: "binary",
        },
        {
            category: "finance",
            clientInteraction: "single",
            clientTitle: "Private Pay Time Period",
            communityInteraction: "multiple",
            communityTitle: "Accepted Spend Down Periods (check all accepted)",
            internal_key: "SpendDownPeriod",
            key: "Question_SpendDownPeriod",
            matchingCriteria: "clientsubset",
            order: 70100,
            prompts: [
                {
                    client: "2+ years",
                    community: "2+ years Private Pay",
                    key: "Option_2Years",
                    order: 1000,
                },
                {
                    client: "1+ year",
                    community: "1+ year Private Pay",
                    key: "Option_1Year",
                    order: 2000,
                },
                {
                    client: "6+ months",
                    community: "6+ months Private Pay",
                    key: "Option_6Months",
                    order: 3000,
                },
                {
                    client: "Direct Medicaid",
                    community: "Direct Medicaid",
                    key: "Option_DirectMedicaid",
                    order: 4000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "finance",
            clientAnnotation: "single",
            clientInteraction: "binary",
            clientTitle: "Needs Affordable / Low-Income Housing",
            communityInteraction: "binary",
            communityTitle: "Offers Affordable / Low-Income Options",
            internal_key: "AffordableHousing",
            key: "Question_AffordableHousing",
            matchingCriteria: "equal",
            order: 80100,
            questionType: "binary",
        },
        {
            category: "otherDetails",
            clientInteraction: "multiple",
            clientTitle: "Other",
            communityInteraction: "multiple",
            communityTitle: "Other",
            internal_key: "SmokingAndAlcohol",
            key: "Question_OtherDetailOptions",
            matchingCriteria: "clientsubset",
            order: 1000,
            prompts: [
                {
                    client: "Smoker",
                    community: "Smoking allowed outside",
                    key: "Option_Smokes",
                    order: 1000,
                },
                {
                    client: "Prefers community that allows Alcohol",
                    community: "Alcohol OK",
                    key: "Option_Alcohol",
                    order: 2000,
                },
            ],
            questionType: "nary",
            supportAnyAndAllSearch: "true",
        },
        {
            category: "otherDetails",
            clientInteraction: "multiple",
            clientTitle: "Marijuana",
            communityInteraction: "multiple",
            communityTitle: "Marijuana",
            key: "Question_OtherDetailMarijuana",
            matchingCriteria: "clientsubset",
            order: 2000,
            prompts: [
                {
                    client: "Marijuana Smoker (outside)",
                    community: "Allows Marijuana Smoking (outside)",
                    key: "Option_MarijuanaSmoker",
                    order: 1000,
                },
                {
                    client: "Uses edible marijuana",
                    community: "Allows edible marijuana",
                    key: "Option_EdibleMJ",
                    order: 2000,
                },
                {
                    client: "Uses topical marijuana",
                    community: "Allows topical marijuana",
                    key: "Option_TopicalMJ",
                    order: 3000,
                },
            ],
            questionType: "nary",
            supportAnyAndAllSearch: "true",
        },
        {
            category: "otherDetails",
            clientAnnotation: "single",
            clientInteraction: "multiple",
            clientTitle: "Pets",
            communityInteraction: "multiple",
            communityTitle: "Pets",
            internal_key: "PetsAllowed",
            key: "Question_Pets",
            matchingCriteria: "clientsubset",
            order: 3000,
            prompts: [
                {
                    client: "Has Dog",
                    clientAnnotation: true,
                    community: "Dogs Allowed",
                    key: "Option_Dog",
                    order: 1,
                },
                {
                    client: "Has Cat",
                    clientAnnotation: true,
                    community: "Cats Allowed",
                    key: "Option_Cat",
                    order: 2,
                },
                {
                    client: "Needs assistance with pet",
                    clientAnnotation: true,
                    community: "Offers assistance with pets",
                    key: "Option_PetAssistance",
                    order: 3,
                },
            ],
            questionType: "nary",
        },
        {
            category: "services",
            clientInteraction: "multiline",
            clientTitle: "Primary Diagnosis",
            communityInteraction: "none",
            key: "Question_PrimaryDiag",
            order: 2000,
            questionType: "text",
        },
        {
            category: "services",
            clientAnnotation: "single",
            clientInteraction: "multiple",
            clientTitle: "Personality/Behavior",
            communityInteraction: "multiple",
            communityTitle: "Personality/Behaviors",
            internal_key: "PersonalityBehaviors",
            key: "Question_PersonalityBehaviors",
            matchingCriteria: "clientsubset",
            order: 3000,
            prompts: [
                {
                    client: "Quiet/Pleasant",
                    clientAnnotation: true,
                    community: "Quiet/Pleasant",
                    key: "Option_Quiet",
                    order: 1000,
                },
                {
                    client: "Social",
                    clientAnnotation: true,
                    community: "Social",
                    key: "Option_Social",
                    order: 2000,
                },
                {
                    client: "Activities/Hobbies",
                    clientAnnotation: true,
                    community: "Activities/Hobbies",
                    key: "Option_Activities",
                    order: 3000,
                },
                {
                    client: "Combative",
                    clientAnnotation: true,
                    community: "Combative",
                    key: "Option_Combative",
                    order: 4000,
                },
                {
                    client: "Refuses Care",
                    clientAnnotation: true,
                    community: "Refuses Care",
                    key: "Option_RefusesCare",
                    order: 5000,
                },
                {
                    client: "Verbally Abusive",
                    clientAnnotation: true,
                    community: "Verbally Abusive",
                    key: "Option_VerbAbusive",
                    order: 6000,
                },
                {
                    client: "Wander Risk",
                    clientAnnotation: true,
                    community: "Wander Risk",
                    key: "Option_Wanderer",
                    order: 7000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "services",
            clientAnnotation: "single",
            clientInteraction: "multiple",
            clientTitle: "Cognition",
            communityInteraction: "multiple",
            communityTitle: "Cognition Levels Accepted",
            internal_key: "Cognition",
            key: "Question_Cognition",
            matchingCriteria: "clientsubset",
            order: 4000,
            prompts: [
                {
                    client: "Alert / No Dementia",
                    clientAnnotation: false,
                    community: "Alert / No Dementia",
                    key: "Option_Alert",
                    order: 1000,
                },
                {
                    client: "Some Memory Loss",
                    clientAnnotation: true,
                    community: "Some Memory Loss",
                    key: "Option_MemoryLoss",
                    order: 2000,
                },
                {
                    client: "Dementia",
                    clientAnnotation: true,
                    community: "Dementia",
                    key: "Option_Dementia",
                    order: 3000,
                },
                {
                    client: "Alzheimer's",
                    clientAnnotation: true,
                    community: "Alzheimer's",
                    key: "Option_Alz",
                    order: 4000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "services",
            clientInteraction: "multiple",
            clientTitle: "Diabetic Needs",
            communityInteraction: "multiple",
            communityTitle: "Diabetic Needs Accepted",
            internal_key: "Diabetic",
            key: "Question_Diabetic",
            matchingCriteria: "clientsubset",
            order: 5000,
            prompts: [
                {
                    client: "Glucose Checks",
                    community: "Glucose Checks",
                    key: "Option_GlucoseChecks",
                    order: 500,
                },
                {
                    client: "Managed by Diet",
                    community: "Managed by Diet",
                    key: "Option_Diet",
                    order: 1000,
                },
                {
                    client: "Oral Medications",
                    community: "Oral Medications",
                    key: "Option_Orals",
                    order: 2000,
                },
                {
                    client: "Standard Insulin",
                    community: "Standard Insulin",
                    key: "Option_Insulin",
                    order: 3000,
                },
                {
                    client: "Sliding Scale Insulin",
                    community: "Sliding Scale Allowed",
                    key: "Option_SlidingScale",
                    order: 4000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "services",
            clientAnnotation: "single",
            clientInteraction: "multiple",
            clientRules: {
                operator: "naryany",
                question: "Question_Diabetic",
            },
            clientTitle: "Diabetic Assistance Needs",
            communityInteraction: "multiple",
            communityTitle: "Diabetic Assistance Offered",
            internal_key: "Diabetic",
            key: "Question_DiabeticAssistanceOffered",
            matchingCriteria: "clientsubset",
            order: 5200,
            prompts: [
                {
                    client: "Independent / No assistance needed",
                    clientAnnotation: false,
                    community: "No assistance available",
                    key: "Option_NoAssistance",
                    order: 500,
                },
                {
                    client: "Needs reminders only",
                    clientAnnotation: true,
                    community: "Reminders only",
                    key: "Option_ReminderOnly",
                    order: 1000,
                },
                {
                    client: "Needs nurse assistance",
                    clientAnnotation: true,
                    community: "Nurse assistance",
                    key: "Option_NurseAssistance",
                    order: 2000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "services",
            clientAnnotation: "single",
            clientInteraction: "multiple",
            clientTitle: "Additional Care Needs",
            communityAnnotation: "single",
            communityInteraction: "multiple",
            communityTitle: "Additional Care Services",
            internal_key: "AdditionalCare",
            key: "Question_AdditionalCare",
            matchingCriteria: "clientsubset",
            order: 6500,
            prompts: [
                {
                    client: "Awake Caregiver at Night",
                    clientAnnotation: true,
                    community: null,
                    communityAnnotation: true,
                    key: "Option_NightCaregiver",
                    order: 1000,
                },
                {
                    client: "Feeding Tube",
                    clientAnnotation: true,
                    community: "Feeding Tube",
                    communityAnnotation: true,
                    key: "Option_Tube",
                    order: 2000,
                },
                {
                    client: "Tracheotomy Care",
                    clientAnnotation: true,
                    community: "Tracheotomy Care",
                    communityAnnotation: true,
                    key: "Option_Trach",
                    order: 3000,
                },
                {
                    client: "Wound Care",
                    clientAnnotation: true,
                    community: "Wound Care",
                    communityAnnotation: true,
                    key: "Option_Wound",
                    order: 4000,
                },
                {
                    client: "Oxygen",
                    clientAnnotation: true,
                    community: "Oxygen",
                    communityAnnotation: true,
                    key: "Option_Oxy",
                    order: 5000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "services",
            clientInteraction: "none",
            communityInteraction: "singleline",
            communityTitle: "Number of Nighttime Checks",
            internal_key: "NumberOfNighttimeChecks",
            key: "Question_NumNightChecks",
            order: 7000,
            questionType: "text",
        },
        {
            category: "services",
            clientInteraction: "multiline",
            clientTitle: "Other Health Notes",
            communityInteraction: "multiline",
            communityTitle: "Other Health Service Notes",
            internal_key: "OtherHealthServiceNotes",
            key: "Question_OtherHealthNotes",
            order: 9000,
            questionType: "text",
        },
        {
            category: "activity",
            clientAnnotation: "single",
            clientInteraction: "multiple",
            clientTitle: "Ambulation",
            communityInteraction: "multiple",
            communityTitle: "Ambulation",
            internal_key: "Ambulation",
            key: "Question_Ambulation",
            matchingCriteria: "clientsubset",
            order: 1000,
            prompts: [
                {
                    client: "Independent",
                    clientAnnotation: false,
                    community: "Independent",
                    key: "Option_Ind",
                    order: 1000,
                },
                {
                    client: "Cane",
                    clientAnnotation: true,
                    community: "Cane",
                    key: "Option_Cane",
                    order: 1500,
                },
                {
                    client: "Walker",
                    clientAnnotation: true,
                    community: "Walker",
                    key: "Option_Walker",
                    order: 2000,
                },
                {
                    client: "Wheelchair",
                    clientAnnotation: true,
                    community: "Wheelchair",
                    key: "Option_Wheelchair",
                    order: 3000,
                },
                {
                    client: "Power Wheelchair",
                    clientAnnotation: true,
                    community: "Power Wheelchair",
                    key: "Option_PowerWheelchair",
                    order: 4000,
                },
                {
                    client: "Bedridden",
                    clientAnnotation: true,
                    community: "Bedridden",
                    key: "Option_Bedridden",
                    order: 5000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "activity",
            clientAnnotation: "single",
            clientInteraction: "multiple",
            clientTitle: "Ability to Transfer",
            communityInteraction: "multiple",
            communityTitle: "Ability to Transfer Accepted",
            internal_key: "Transfer",
            key: "Question_Transfer",
            matchingCriteria: "clientsubset",
            order: 2000,
            prompts: [
                {
                    client: "Independent",
                    clientAnnotation: false,
                    community: "Independent",
                    key: "Option_Independent",
                    order: 1000,
                },
                {
                    client: "Stand-by",
                    clientAnnotation: true,
                    community: "Standby",
                    key: "Option_Standby",
                    order: 2000,
                },
                {
                    client: "1 Person Transfer",
                    clientAnnotation: true,
                    community: "1 Person Transfer",
                    key: "Option_1Person",
                    order: 3000,
                },
                {
                    client: "2 Person Transfer",
                    clientAnnotation: true,
                    community: "2 Person Transfer",
                    key: "Option_2Person",
                    order: 4000,
                },
                {
                    client: "Hoyer or Sit-Stand Lift",
                    clientAnnotation: true,
                    community: "Hoyer or Sit-Stand Lift",
                    key: "Option_Hoyer",
                    order: 5000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "activity",
            clientAnnotation: "perAnswer",
            clientInteraction: "multiple",
            clientTitle: "Assistance Needed With:",
            communityInteraction: "none",
            key: "Question_AssistanceNeeds",
            order: 3000,
            prompts: [
                {
                    client: "Feeding Assistance",
                    clientAnnotation: true,
                    key: "Option_Feed",
                    order: 1000,
                },
                {
                    client: "Toileting Assistance",
                    clientAnnotation: true,
                    key: "Option_Toilet",
                    order: 2000,
                },
                {
                    client: "Bathing, Standby help",
                    clientAnnotation: true,
                    key: "Option_Bath_Standby",
                    order: 3000,
                },
                {
                    client: "Bathing, Full help",
                    clientAnnotation: true,
                    key: "Option_Bath_Full",
                    order: 4000,
                },
                {
                    client: "Grooming, Setup",
                    clientAnnotation: true,
                    key: "Option_Groom_Setup",
                    order: 5000,
                },
                {
                    client: "Grooming, Full Assist",
                    clientAnnotation: true,
                    key: "Option_Groom_Full",
                    order: 6000,
                },
                {
                    client: "Dressing, Lay out clothes",
                    clientAnnotation: true,
                    key: "Option_Dress_Layout",
                    order: 7000,
                },
                {
                    client: "Dressing, Full assist",
                    clientAnnotation: true,
                    key: "Option_Dress_Full",
                    order: 8000,
                },
                {
                    client: "Other",
                    clientAnnotation: true,
                    key: "Option_Other",
                    order: 9000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "activity",
            clientAnnotation: "single",
            clientInteraction: "multiple",
            clientTitle: "Incontinence",
            communityInteraction: "multiple",
            communityTitle: "Incontinence Needs Accepted",
            internal_key: "Incontinence",
            key: "Question_Incontinence",
            matchingCriteria: "clientsubset",
            order: 4000,
            prompts: [
                {
                    client: "Bladder Incontinence",
                    clientAnnotation: true,
                    community: "Bladder Incontinence",
                    key: "Option_Bladder",
                    order: 3000,
                },
                {
                    client: "Bowel Incontinence",
                    clientAnnotation: true,
                    community: "Bowel Incontinence",
                    key: "Option_Bowel",
                    order: 4000,
                },
                {
                    client: "Foley",
                    clientAnnotation: true,
                    community: "Foley",
                    key: "Option_Foley",
                    order: 5000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "activity",
            clientAnnotation: "single",
            clientInteraction: "multiple",
            clientTitle: "Special Dietary Needs",
            communityInteraction: "multiple",
            communityTitle: "Accommodates Special Diets",
            internal_key: "Diet",
            key: "Question_Diets",
            matchingCriteria: "clientsubset",
            order: 5000,
            prompts: [
                {
                    client: "Pureed Diet",
                    clientAnnotation: true,
                    community: "Pureed Diet",
                    key: "Option_Puree",
                    order: 1000,
                },
                {
                    client: "Mechanical Soft Diet",
                    clientAnnotation: true,
                    community: "Mechanical Soft Diet",
                    key: "Option_MD",
                    order: 2000,
                },
                {
                    client: "Vegetarian",
                    clientAnnotation: true,
                    community: "Vegetarian",
                    key: "Option_Veg",
                    order: 3000,
                },
                {
                    client: "Gluten Free",
                    clientAnnotation: true,
                    community: "Gluten Free",
                    key: "Option_GF",
                    order: 4000,
                },
                {
                    client: "Dairy Free",
                    clientAnnotation: true,
                    community: "Dairy Free",
                    key: "Option_DF",
                    order: 5000,
                },
            ],
            questionType: "nary",
        },
        {
            category: "amenity",
            clientInteraction: "binary",
            clientTitle: "Activities",
            communityInteraction: "binary",
            communityTitle: "Activities (regularly scheduled)",
            internal_key: "Activities",
            key: "Question_Activities",
            order: 2000,
            questionType: "binary",
        },
        {
            category: "amenity",
            clientInteraction: "binary",
            clientTitle: "Fitness Center",
            communityInteraction: "binary",
            communityTitle: "Fitness Center",
            internal_key: "FitnessCenter",
            key: "Question_FitnessCenter",
            order: 3000,
            questionType: "binary",
        },
        {
            category: "amenity",
            clientInteraction: "binary",
            clientTitle: "Optional Dining",
            communityInteraction: "binary",
            communityTitle: "Optional Dining",
            internal_key: "OptionalDining",
            key: "Question_OptionalDining",
            order: 4000,
            questionType: "binary",
        },
        {
            category: "amenity",
            clientInteraction: "binary",
            clientTitle: "Pool",
            communityInteraction: "binary",
            communityTitle: "Pool",
            internal_key: "Pool",
            key: "Question_Pool",
            order: 5000,
            questionType: "binary",
        },
        {
            category: "amenity",
            clientInteraction: "binary",
            clientTitle: "Reading Materials",
            communityInteraction: "binary",
            communityTitle: "Reading Materials",
            internal_key: "ReadingMaterials",
            key: "Question_ReadingMaterials",
            order: 6000,
            questionType: "binary",
        },
        {
            category: "amenity",
            clientInteraction: "binary",
            clientTitle: "Secure Courtyard",
            communityInteraction: "binary",
            communityTitle: "Secure Courtyard",
            internal_key: "SecureCourtyard",
            key: "Question_SecureCourtyard",
            order: 7000,
            questionType: "binary",
        },
        {
            category: "amenity",
            clientInteraction: "binary",
            clientTitle: "Transportation Needed",
            communityInteraction: "binary",
            communityTitle: "Transportation Available",
            internal_key: "TransportationAvailable",
            key: "Question_Transportation",
            order: 7500,
            questionType: "binary",
        },
        {
            category: "amenity",
            clientInteraction: "binary",
            clientTitle: "Walking Paths",
            communityInteraction: "binary",
            communityTitle: "Walking Paths",
            internal_key: "WalkingPaths",
            key: "Question_WalkingPaths",
            order: 8000,
            questionType: "binary",
        },
        {
            category: "amenity",
            clientInteraction: "multiline",
            clientTitle: "Other Amenity Preferences",
            communityInteraction: "multiline",
            communityTitle: "Other Amenity Offerings",
            internal_key: "AmenityNotes",
            key: "Question_AmenityNotes",
            order: 12000,
            questionType: "text",
        },
        {
            category: "socialInterests",
            clientInteraction: "singleline",
            clientTitle: "Hometown",
            communityInteraction: "none",
            key: "Question_Hometown",
            order: 2000,
            questionType: "text",
        },
        {
            category: "socialInterests",
            clientInteraction: "singleline",
            clientTitle: "Past Profession",
            communityInteraction: "none",
            key: "Question_Career",
            order: 3000,
            questionType: "text",
        },
        {
            category: "socialInterests",
            clientInteraction: "singleline",
            clientTitle: "Religion",
            communityInteraction: "none",
            key: "Question_Religion",
            order: 4000,
            questionType: "text",
        },
        {
            category: "socialInterests",
            clientInteraction: "multiline",
            clientTitle: "Hobbies / Interests",
            communityInteraction: "none",
            key: "Question_Hobbies",
            order: 5000,
            questionType: "text",
        },
    ],
    license: [
        {
            category: "communityRecords",
            clientInteraction: "none",
            communityInteraction: "singleline",
            communityTitle: "License Number",
            internal_key: "LicenseNumber",
            key: "Question_LicenseNum",
            order: 1000,
            questionType: "text",
        },
        {
            category: "communityRecords",
            clientInteraction: "none",
            communityInteraction: "singleline",
            communityTitle: "Licensee",
            internal_key: "Licensee",
            key: "Question_Licensee",
            order: 2000,
            questionType: "text",
        },
        {
            category: "communityRecords",
            clientInteraction: "none",
            communityInteraction: "url",
            communityTitle: "State Licensing Records",
            internal_key: "StateRecords",
            key: "Question_StateLookup",
            order: 3000,
            questionType: "text",
        },
    ],
    medicaid: [
        {
            category: "finance",
            clientAnnotation: "single",
            clientInteraction: "binary",
            clientTitle: "Will Need Medicaid",
            communityInteraction: "binary",
            communityTitle: "Has Medicaid Contract",
            internal_key: "Medicaid",
            key: "Question_Medicaid",
            matchingCriteria: "equal",
            order: 60100,
            questionType: "binary",
        },
    ],
    or: [
        {
            category: "type",
            clientInteraction: "multiple",
            clientRules: {
                contains: "Option_AdultCareHome",
                operator: "naryvalue",
                question: "Question_CommunityTypes",
            },
            clientTitle: "Adult Care Home Level",
            communityInteraction: "multiple",
            communityRules: {
                contains: "Option_AdultCareHome",
                operator: "naryvalue",
                question: "Question_CommunityTypes",
            },
            communityTitle: "Adult Care Home Level",
            key: "Question_CareLevel",
            matchingCriteria: "clientsubset",
            order: 500,
            prompts: [
                {
                    client: "Class 1",
                    community: "Class 1",
                    key: "Option_Class1",
                    order: 100,
                },
                {
                    client: "Class 2",
                    community: "Class 2",
                    key: "Option_Class2",
                    order: 200,
                },
                {
                    client: "Class 3",
                    community: "Class 3",
                    key: "Option_Class3",
                    order: 300,
                },
            ],
            questionType: "nary",
            supportAnyAndAllSearch: "true",
        },
    ],
    tx: [
        {
            category: "type",
            clientInteraction: "multiple",
            clientRules: {
                operand0: {
                    contains: "Option_AssistedLiving",
                    operator: "naryvalue",
                    question: "Question_CommunityTypes",
                },
                operand1: {
                    contains: "Option_PersonalCareHome",
                    operator: "naryvalue",
                    question: "Question_CommunityTypes",
                },
                operator: "or",
            },
            clientTitle: "Service Type",
            communityInteraction: "multiple",
            communityRules: {
                operand0: {
                    contains: "Option_AssistedLiving",
                    operator: "naryvalue",
                    question: "Question_CommunityTypes",
                },
                operand1: {
                    contains: "Option_PersonalCareHome",
                    operator: "naryvalue",
                    question: "Question_CommunityTypes",
                },
                operator: "or",
            },
            communityTitle: "Service Type",
            internal_key: "ServiceType",
            key: "Question_ServiceTypes",
            matchingCriteria: "clientsubset",
            order: 2000,
            prompts: [
                {
                    client: "Type A",
                    community: "Type A",
                    key: "Option_A",
                    order: 1000,
                },
                {
                    client: "Type B",
                    community: "Type B",
                    key: "Option_B",
                    order: 2000,
                },
                {
                    client: "Type C",
                    community: "Type C",
                    key: "Option_C",
                    order: 3000,
                },
            ],
            questionType: "nary",
            supportAnyAndAllSearch: "true",
        },
        {
            category: "type",
            clientInteraction: "none",
            communityInteraction: "binary",
            communityRules: {
                contains: "Option_Hospice",
                operator: "naryvalue",
                question: "Question_CommunityTypes",
            },
            communityTitle: "In-Patient Hospice",
            key: "Question_InPatientHospice",
            order: 2100,
            questionType: "nary",
            supportAnyAndAllSearch: "true",
        },
        {
            category: "type",
            clientInteraction: "none",
            communityInteraction: "binary",
            communityTitle: "Certified",
            key: "Question_Certified",
            order: 2200,
            questionType: "nary",
            supportAnyAndAllSearch: "true",
        },
    ],
    mimi: [
        {
            key: "Question_MedicationManagement",
            order: -1000,
            questionType: "binary",
            category: "services",
            clientAnnotation: "single",
            clientInteraction: "binary",
            communityInteraction: "none",
            communityAnnotation: "none",
        },
        {
            key: "Question_PaymentTypes",
            order: 1500,
            questionType: "nary",
            category: "finance",
            clientInteraction: "single",
            clientAnnotation: "single",
            clientRules: null,
            clientTitle: "Private Pay Types",
            communityInteraction: "multiple",
            communityAnnotation: "none",
            communityRules: null,
            communityTitle: "Private Pay Acceptance",
            prompts: [
                {
                    client: "Long-Term Care Insurance",
                    clientAnnotation: true,
                    community: "Long-Term Care Insurance",
                    communityAnnotation: false,
                    key: "prompt-long-term-care-insurance",
                    order: -1000,
                },
                {
                    client: "Private Pay",
                    clientAnnotation: true,
                    community: "Private Pay",
                    communityAnnotation: false,
                    key: "prompt-private-pay",
                    order: -500,
                },
                {
                    client: "Medicaid",
                    clientAnnotation: true,
                    community: "Medicaid",
                    communityAnnotation: false,
                    key: "prompt-medicaid",
                    order: 0,
                },
            ],
        },
        {
            key: "Question_LanguagesSpoken",
            order: 1000,
            category: "socialInterests",
            clientTitle: "Clients Spoken Languages",
            communityTitle: "",
            questionType: "text",
            clientInteraction: "singleline",
            clientAnnotation: "none",
            communityInteraction: "none",
            communityAnnotation: "none",
            prompts: [],
        },
        {
            key: "Question_Vision",
            order: 2000,
            category: "otherDetails",
            clientTitle: "Client Vision",
            communityTitle: "",
            questionType: "nary",
            clientInteraction: "multipleDropdown",
            clientAnnotation: "single",
            communityInteraction: "none",
            communityAnnotation: "none",
            prompts: [
                { client: "Poor", community: "", key: "prompt-poor", order: 1 },
                { client: "Blind", community: "", key: "prompt-blind", order: 3 },
                { client: "Glasses", community: "", key: "prompt-glasses", order: 2 },
                { client: "Good", community: "", key: "prompt-good", order: 0 },
            ],
        },
        {
            key: "Question_Hearing",
            order: 3000,
            category: "otherDetails",
            clientTitle: "Client Hearing",
            communityTitle: "",
            questionType: "nary",
            clientInteraction: "multipleDropdown",
            clientAnnotation: "single",
            communityInteraction: "none",
            communityAnnotation: "none",
            prompts: [
                { client: "Good", community: "", key: "prompt-good", order: 0 },
                { client: "Poor", community: "", key: "prompt-poor", order: 1 },
                {
                    client: "Hearing-Aid",
                    community: "",
                    key: "prompt-hearing-aid",
                    order: 1,
                },
                { client: "Deaf", community: "", key: "prompt-deaf", order: 2 },
            ],
        },
        {
            key: "Question_Speech",
            order: 4000,
            category: "otherDetails",
            clientTitle: "Client Speech",
            communityTitle: "",
            questionType: "nary",
            clientInteraction: "multipleDropdown",
            clientAnnotation: "single",
            communityInteraction: "none",
            communityAnnotation: "none",
            prompts: [
                {
                    client: "Mute/Nonverbal",
                    community: "",
                    key: "prompt-mute-nonverbal",
                    order: 2,
                },
                { client: "Poor", community: "", key: "prompt-poor", order: 1 },
                { client: "Good", community: "", key: "prompt-good", order: 0 },
                { client: "Aphasia", community: "", key: "prompt-aphasia", order: 3 },
            ],
        },
        {
            key: "Question_MilitaryService",
            order: 5000,
            category: "socialInterests",
            clientTitle: "Military Service History",
            communityTitle: "",
            questionType: "binary",
            clientInteraction: "binary",
            clientAnnotation: "single",
            communityInteraction: "none",
            communityAnnotation: "none",
            prompts: [],
        },
    ],
};
//# sourceMappingURL=canned-settings.js.map